import React, { useState } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import DOMPurify from 'dompurify';

const TransactionTestingWidget = props => {
  const [active, setActive] = useState(true);

  const handleAccordionClick = () => {
    setActive(!active);
  };

  const boldText = () => ({
    fontFamily: 'PublicSans-Bold',
    fontWeight: 400,
  });

  return (
    <div style={{ marginTop: 20 }}>
      <Accordion fluid>
        <Accordion.Title
          active={active}
          onClick={handleAccordionClick}
          style={{ backgroundColor: '#DCDCDC', marginTop: 20 }}
        >
          <h3 style={{ marginLeft: '10px' }}>
            Transactions Summary
            <Icon style={{ float: 'right' }} name={active ? 'minus' : 'plus'} />
          </h3>
        </Accordion.Title>

        <Accordion.Content active={active}>
          <div
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              margin: '15px 0',
              color: '#333',
            }}
          >
            The following transactions were tied to this TQ for review.
          </div>
          {props?.schema?.transactions?.map((txnGroup, idx) => (
            <div key={idx} style={{ marginBottom: 20 }}>
              <h3 style={{ margin: '10px 0' }}>{txnGroup.title}</h3>
              {txnGroup.transactionData
                .filter(
                  txn =>
                    txn?.category !== null &&
                    txn?.income !== null &&
                    txn?.notes !== null
                )
                .map((txn, tIdx) => (
                  <div
                    key={tIdx}
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      padding: '10px',
                      marginBottom: '8px',
                      backgroundColor: '#fafafa',
                    }}
                  >
                    <span style={boldText()}>Category:</span> {txn?.category}
                    <br />
                    <span style={boldText()}>Amount of transaction:</span> $
                    {txn?.income}
                    <br />
                    <span style={boldText()}>Notes:</span>
                    <br />
                    <span
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(txn?.notes),
                      }}
                    ></span>
                  </div>
                ))}
            </div>
          ))}
        </Accordion.Content>
      </Accordion>
    </div>
  );
};

export default TransactionTestingWidget;
